export const mapDenominableToOption = (entity: any) => (
    {
        label: entity.denominacion || '',
        value: entity.id,
})